import {
  getContractAssociationForm,
  getContractMediationList,
  submitContractAcceptance,
} from '../services';

export default {
  namespace: 'contractDetail',
  state: {},
  effects: {
    *getContractMediationList({ payload }, { call }) {
      const res = yield call(getContractMediationList, payload);
      return res;
    },

    *submitContractAcceptance({ payload }, { call }) {
      const res = yield call(submitContractAcceptance, payload);
      return res;
    },

    *getContractAssociationForm({ payload }, { call }) {
      const res = yield call(getContractAssociationForm, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
